import React, { act, useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import PageHeader from '../../core/components/layout/PageHeader'
import { Box, Container, Stack, useTheme } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ManageSubscription from './ManageSubscription';
import PaymentHistory from './PaymentHistory';
import PaymentMethods from './PaymentMethods';
import Billing from './Billing';
import { BillingProvider, useBilling } from './BillingProvider';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}
function BillingLayout() {
    const { activeTab, setActiveTab } = useBilling();
    const theme = useTheme();
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };
    const navigation = useNavigate()
    useEffect(() => {
        if (activeTab === 0 || activeTab === 2) {
            navigation('/billing', {
                replace: true
            })
        }
    }, [activeTab])
    return (
        <Container maxWidth='xl' sx={{ 
            [theme.breakpoints.down('sm')]: {
                width: 'calc(100vw - 10px)'
            },
          
         }}>
            <Stack spacing={3} >
                <PageHeader title="Billing & Payments" description="Manage Your billing, wallet and payment settings" />
                <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example"
                    style={{
                        borderBottom: '1px solid #e0e0e0',
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Current Billing" {...a11yProps(0)}
                        style={{
                            fontWeight: '500',
                            fontSize: 16
                        }} />
                    <Tab label="Manage Subscription" {...a11yProps(1)}
                        style={{
                            fontWeight: '500',
                            fontSize:16
                        }}
                    />
                    <Tab label="Payment History" {...a11yProps(2)}
                        style={{
                            fontWeight: '500',
                            fontSize: 16
                        }} />
                    <Tab label="Payment Methods" {...a11yProps(3)} style={{
                        fontWeight: '500',
                        fontSize: 16
                    }} />
                </Tabs>
                <CustomTabPanel value={activeTab} index={0}>
                    <Billing />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={1}>
                    <ManageSubscription />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={2}>
                    <PaymentHistory />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={3}>
                    <PaymentMethods />
                </CustomTabPanel>
            </Stack>
        </Container>
    )
}
const BillingProviderLayout = () => {
    return <BillingProvider>
        <BillingLayout />
    </BillingProvider>
}
export default BillingProviderLayout